import { useState, useEffect } from "react";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import FnrPaymentMethodIcon from "UI/FnrPaymentMethodIcon";

export default function CardIcon() {
  const {
    state: { paymentMethods, selectedPaymentMethodID },
  } = usePaymentPage();

  const [paymentMethod, setPaymentMethod] = useState({});
  const { cardType } = paymentMethod;

  useEffect(() => {
    if (
      !selectedPaymentMethodID ||
      !paymentMethods ||
      paymentMethods.length === 0
    )
      return;

    const selectedMethod = paymentMethods.find(
      (p) => p.ID === selectedPaymentMethodID
    );
    if (selectedMethod) setPaymentMethod(selectedMethod);
  }, [paymentMethods, selectedPaymentMethodID]);

  return <FnrPaymentMethodIcon cardType={cardType} />;
}
